import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const MainContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 15,
}));

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 5,
}));

// New Styled Component

export const TextSwitchColor = styled('p')(({ theme, size, withBreakSpaces }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.DARK,
  whiteSpace: withBreakSpaces ? 'break-spaces' : undefined,
}));
